/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_Go_HomeInputs */

const vi_not_found_go_home = /** @type {(inputs: Not_Found_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về trang chính`)
};

/**

* @param {Not_Found_Go_HomeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const not_found_go_home = /** @type {((inputs?: Not_Found_Go_HomeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_Go_HomeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_not_found_go_home(inputs)
});